import { API as MOCK_AMPLIFY_API } from '../__mocks__/aws-amplify';
import { API as AMPLIFY_API } from 'aws-amplify';
import { searchParticipantsQuery, getParticipantQuery, searchSitesQuery, getSiteQuery } from '../graphql/queries';
import { ParticipantSearchResponseFull, ParticipantResponse, GraphQlError, SiteResponse } from '../types/common.types';
import { ParticipantSearchRequest } from '../../store/participants';
import { SiteSearchResponseFull } from '../../store/sites';

const API = process.env.REACT_APP_USE_MOCKS === 'true' ? MOCK_AMPLIFY_API : AMPLIFY_API;

const portalApi = {
  searchParticipants: async (request: ParticipantSearchRequest): Promise<any> => {
    try {
      return (await API.graphql({
        query: searchParticipantsQuery,
        variables: {
          keyword: request.keyword,
          nextToken: request.nextToken,
        },
      })) as ParticipantSearchResponseFull;
    } catch (error) {
      return error as GraphQlError;
    }
  },
  getParticipant: async (id: string): Promise<any> => {
    try {
      return (await API.graphql({
        query: getParticipantQuery,
        variables: {
          participantId: id,
        },
      })) as ParticipantResponse;
    } catch (error) {
      return error as ParticipantResponse;
    }
  },
  searchSites: async (request: ParticipantSearchRequest): Promise<any> => {
    try {
      return (await API.graphql({
        query: searchSitesQuery,
        variables: {
          keyword: request.keyword,
          nextToken: request.nextToken,
        },
      })) as SiteSearchResponseFull;
    } catch (error) {
      return error as GraphQlError;
    }
  },
  getSite: async (code: string): Promise<any> => {
    try {
      return (await API.graphql({
        query: getSiteQuery,
        variables: {
          code: code,
        },
      })) as SiteResponse;
    } catch (error) {
      return error as SiteResponse;
    }
  },
};

export default portalApi;
